// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__22DS1","cell":"ColumnAccessor_cell__Vg1X9","firstCellAccent":"ColumnAccessor_firstCellAccent__2QR5n"};